import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnRoutingModelsBasicInfoComponent({
    handleInnerFormChange,
    selectedCategory,
    PlanType, FulfillmentExtent, LifeCycleStatus, 
}: any) {
    const formatDateOnly = (dateValue: string) => {
        if (!dateValue) return "";

        return new Date(dateValue).toISOString().split("T")[0];
    };
    return (
        <>
            <AccordionContainer
                headerTitle="New Service Category Group"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">

                        <InputContainer
                            label="Group Code"
                            name="Code"
                            type="text"
                            value={selectedCategory?.Code}
                            isDisabled={!!selectedCategory?.GlobalDBNRoutingModelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                );
                            }}
                        />

                        <InputContainer
                            label="Group Name"
                            name="Name"
                            type="text"
                            value={selectedCategory?.Name}
                            isDisabled={!!selectedCategory?.GlobalDBNRoutingModelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                        />

                        <div className="md:col-span-2">
                            <InputContainer
                                label="Description"
                                name="Description"
                                type="text"
                                value={selectedCategory?.Description}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                            />
                        </div>

                        <div className="text-black">
                            <InputContainer
                                label="Plan Type"
                                labelField="Text"
                                list={PlanType}
                                type="select"
                                optionName="Select Plan Type"
                                value={selectedCategory?.PlannerTypeId}
                                valueField="Value"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        Number(event.target.value),
                                        "PlannerTypeId"
                                    );
                                }}
                            />
                        </div>
                        <div className="text-black">
                            <InputContainer
                                label="Fulfillment Extent Type"
                                labelField="Text"
                                list={FulfillmentExtent}
                                type="select"
                                optionName="Select Plan Type"
                                value={selectedCategory?.FulfillmentExtentId}
                                valueField="Value"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        Number(event.target.value),
                                        "FulfillmentExtentId"
                                    );
                                }}
                            />
                        </div><div className="text-black">
                            <InputContainer
                                label="LifeCycle Status"
                                labelField="Text"
                                list={LifeCycleStatus}
                                type="select"
                                optionName="Select Plan Type"
                                value={selectedCategory?.LifeCycleStatusId}
                                valueField="Value"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        Number(event.target.value),
                                        "LifeCycleStatusId"
                                    );
                                }}
                            />
                        </div>

                    </div>
                }
            />
        </>
    );
}